import * as types from '../../../actions/commonStandards/actionTypes';

export default (state = false, action) => {
  switch (action.type) {
    case types.FETCH_STANDARDS_REQUEST:
      return true;

    case types.FETCH_STANDARDS_SUCCESS:
    case types.FETCH_STANDARDS_FAILURE:
      return false;

    default:
      return state;
  }
};
